module.exports = __webpack_public_path__ + "img/petikom_hero_img.40068a89.jpg";